import { Hero } from '../components/home/Hero';
import { EditorialMarquee } from '../components/home/Marquee';
import { Highlights } from '../components/home/Highlights';
import { ServicesSection } from '../components/home/ServicesSection';
import { FeaturedProjects } from '../components/home/FeaturedProjects';
import { WhyChooseUs } from '../components/home/WhyChooseUs';
import { Testimonials } from '../components/home/Testimonials';
import { ContactCTA } from '../components/home/ContactCTA';

export default function Home() {
  return (
    <main data-testid="home-page">
      <Hero />
      <EditorialMarquee />
      <Highlights />
      <ServicesSection />
      <FeaturedProjects />
      <WhyChooseUs />
      <Testimonials />
      <ContactCTA />
    </main>
  );
}
